import qs from 'qs';

import type { FetcherAxiosInstance } from '../fetcher';

export interface IFetchCatalogProductTiles {
  productIds: string[];
  onlyAvailableProducts?: boolean;
}

export const createCatalogApi = (Fetcher: FetcherAxiosInstance) => ({
  getSearchSuggestions({ query = '' }) {
    return Fetcher.get('/catalog/autocomplete', {
      params: { query },
      paramsSerializer: (params) => qs.stringify(params),
    });
  },

  fetchCatalog(requestBody: { url: string; page: number }) {
    return Fetcher.post('/catalog', requestBody);
  },

  fetchCatalogFacets(url: string) {
    return Fetcher.get('/catalog/facets', { params: { url } });
  },

  fetchCatalogCategoriesTree(categoryUrl: string) {
    return Fetcher.get('/catalog/categories-tree', { params: { categoryUrl } });
  },

  fetchCatalogProductTiles(params: IFetchCatalogProductTiles) {
    const { productIds, onlyAvailableProducts = false } = params;

    return Fetcher.post('/catalog/product-tiles', { productIds, onlyAvailableProducts });
  },

});
